import { withAsyncLoading } from '../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableQuizDetailsPage = withAsyncLoading(async () => import('./QuizDetailsPage').then((res) => res.QuizDetailsPage));

export { LoadableQuizDetailsPage };
